// extracted by mini-css-extract-plugin
module.exports = {"header":"LandingPage_header__2XXrF","hero_text_box":"LandingPage_hero_text_box__VKzXu","btn":"LandingPage_btn__3T-rq"};